<template>
  <div class="mainContainer">
    <div class="nav">
      <el-form  :inline="true" :model="searchForm">
        <el-form-item label="变更编号:" >
          <el-input v-model="searchForm.bgCode" size='mini' placeholder="请输入变更编号"/>
        </el-form-item>
        <el-form-item label="变更类型:" >
          <el-select v-model='searchForm. bgType' filterable size='mini'
                     placeholder='请选择变更类型'>
            <el-option label='全部' value=''></el-option>
            <el-option label='运输计划' value='0'></el-option>
            <el-option label='实际运输' value='1'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="变更原因:" >
          <el-input v-model="searchForm.reason" size='mini' placeholder="请输入变更原因"/>
        </el-form-item>
        <el-form-item label="创建人:" >
          <el-input v-model="searchForm.createName" size='mini' placeholder="请输入创建人"/>
        </el-form-item>
        <el-form-item label="创建时间：">
          <el-date-picker
            size='mini'
            v-model="searchForm.createTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态:" >
          <el-select v-model='searchForm.type' filterable size='mini'
                     placeholder='请选择状态'>
            <el-option label='全部' value=''></el-option>
            <el-option label='保存' value='0'></el-option>
            <el-option label='提交审核' value='1'></el-option>
            <el-option label='已通过' value='2'></el-option>
            <el-option label='已拒绝' value='3'></el-option>
            <el-option label='取消审核' value='4'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' type="primary" @click='addBtn'>新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="content">
      <el-table
        v-loading = "tableLoading"
        :data="tableData"
        border
        style="width: 100%"
        :header-cell-style='headerCellStyle'
      >
        <el-table-column label='序号' align='center' width='50px' type='index' />
        <el-table-column align="center" prop="bgCode" label="变更编号" />
        <el-table-column align="center" prop="bgType" label="变更类型" :formatter="bgTypeFormat"/>
        <el-table-column align="center" prop="reason" label="变更原因" width="250px"/>
        <el-table-column align="center" prop="createName" label="创建人" />
        <el-table-column align="center" prop="createTime" label="创建时间" />
        <el-table-column align="center" prop="type" label="状态" :formatter="typeFormat" width="100px"/>
        <el-table-column label="操作" width="400px" align="center">
          <template slot-scope="scope">
            <el-button size='mini' class='searchBtn' @click='detailClick(scope.row)'>详情</el-button>
            <el-button v-if="scope.row.type !== 2" size='mini' type="warning" @click='updateClick(scope.row)'>修改</el-button>
            <el-button v-if="scope.row.type !== 2 && scope.row.type !== 1" size='mini' type="danger" @click='deleteClick(scope.row)'>删除</el-button>
            <el-button v-if="scope.row.type === 0 || scope.row.type === 4 || scope.row.type === 3" size='mini' type="primary" @click='submitClick(scope.row)'>提交审核</el-button>
            <el-button v-if="scope.row.type === 1" size='mini' type="danger" @click='cancelClick(scope.row)'>取消审核</el-button>
            <el-button size="mini" type="info" @click="historyClick(scope.row)">历史审核记录</el-button>
            <el-button size="mini" type="info" @click="changeSearchClick(scope.row)">变更查询</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class='paginationContainer'>
      <el-pagination
        background
        :page-sizes='[10, 20, 30, 40]'
        layout='total, sizes, prev, pager, next, jumper'
        :total='total'
        @size-change='tableSizeChange'
        @current-change='tableCurrentChange'
        :current-page.sync='searchForm.page'
        :page-size='searchForm.rows'
      />
    </div>
    <!--  新增  -->
    <add-transport ref="addTransportRef" @searchBtn="getTableData"/>
    <!--  详情  -->
    <detail-change ref="detailChangeRef"/>
    <!--  历史审核记录  -->
    <history-review ref="historyReviewRef"/>
    <!--  修改  -->
    <edit-transport ref="editTransportRef" @searchBtn="getTableData"/>
    <!--  变更查询  -->
    <detail-change-table ref="detailChangeTableRef"/>
  </div>
</template>

<script>
import addTransport from "./components/addTransport.vue";
import detailChange from "./components/detailChange.vue";
import historyReview from "./components/historyReview.vue";
import editTransport from './components/editTransport.vue'
import detailChangeTable from "./components/detailChangeTable.vue";
import {
  changeDelete,
  getTableDataList,
  resubmitReview,
  withdrawReview,
} from '@/service/vehiclelog';

export default {
  name: "index.vue",
  components:{addTransport,detailChange,historyReview,editTransport,detailChangeTable},
  data() {
    return {
      searchForm:{
        bgCode: '',
        bgType: '',
        reason: '',
        createName: '',
        createTime: [],
        type: '',
        page: 1,
        rows: 10,
      },
      tableLoading:false,
      tableData: [],
      headerCellStyle: {
        'color': '#3B3B3B',
        'font-size': '13px',
        'height': '48px',
        'background': '#E8E8E8',
      },
      total: 0
    }
  },
  mounted() {
    this.defaultForm = JSON.parse(JSON.stringify(this.searchForm));
  },
  methods:{
    //查询
    searchBtn(){
      this.getTableData()
    },
    //获取数据
    async getTableData() {
      this.tableLoading = true;
      const res = await getTableDataList({
        bgCode: this.searchForm.bgCode,
        bgType: this.searchForm.bgType,
        reason: this.searchForm.reason,
        createName: this.searchForm.createName,
        startTime: this.searchForm.createTime[0],
        endTime: this.searchForm.createTime[1],
        type: this.searchForm.type,
        page: this.searchForm.page,
        rows: this.searchForm.rows,
      });
      this.tableLoading = false;
      if (res.status !== null) return this.$message.warning(res.message);
      this.tableData = res.data.records;
      this.total = res.data.total;
    },
    //重置
    resetBtn(){
      this.searchForm = JSON.parse(JSON.stringify(this.defaultForm));
    },
    //新增
    addBtn(){
      this.$confirm('请选择新增方式', '提示', {
        confirmButtonText: '实际运输变更',
        cancelButtonText: '运输计划变更',
        distinguishCancelAndClose: true,
        type: 'warning',
      })
        .then(() => {
          this.$nextTick(() => {
            this.$refs.addTransportRef.dialogOpen(1);
          });
        })
        .catch((action) => {
          if (action == 'close') return;
          this.$nextTick(() => {
            this.$refs.addTransportRef.dialogOpen(0);
          });
        });
    },
    //详情
    detailClick(row){
      this.$refs.detailChangeRef.dialogOpen(row)
    },
    //修改
    updateClick(row){
      if(row.bgType === 0){
        this.$refs.editTransportRef.dialogOpen(row)
      }else {
        this.$refs.editTransportRef.dialogOpen(row)
      }
    },
    //删除
    deleteClick(row){
      this.$confirm('是否确定删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await changeDelete(row.id,row.type)
        if(res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        await this.getTableData();
      }).catch(() => false);
    },
    //提交审核
    submitClick(row){
      if(row.type === 3) return this.$message.warning('请先修改')
      this.$confirm('确定要提交审核吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
          const res = await resubmitReview({
            id:row.id,
          });
          if (res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          await this.getTableData();
        })
        .catch(() => {});
    },
    //取消审核
    cancelClick(row){
      this.$confirm('确定要取消审核吗','提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type:'warning'
      })
        .then(async () => {
          const res = await withdrawReview({
            id:row.id
          });
          if (res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          await this.getTableData();
        })
        .catch(() => {});
    },
    //历史审核记录
    historyClick(row){
      this.$refs.historyReviewRef.dialogOpen(row.id)
    },
    //变更查询
    changeSearchClick(row){
      this.$refs.detailChangeTableRef.dialogOpen(row)
    },
    typeFormat(row, column, cellValue) {
      switch (cellValue) {
        case 0:
          return '保存';
        case 1:
          return '提交审核';
        case 2:
          return '已通过';
        case 3:
          return '已拒绝';
        case 4:
          return '取消审核';
      }
    },
    bgTypeFormat(row, column, cellValue) {
      switch (cellValue) {
        case 0:
          return '运输计划';
        case 1:
          return '实际运输';
      }
    },
    tableSizeChange(row) {
      this.searchForm.rows = row;
      this.searchForm.page = 1;
      this.getTableData();
    },
    tableCurrentChange(page) {
      this.searchForm.page = page;
      this.getTableData();
    },
  }

}
</script>

<style scoped>
.mainContainer{
  width: 100%;
  padding: 20px 15px 0 15px;
  background-color: #fff;

  .nav {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &Btn {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
  }

  .content {
    .paginationContainer {
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-top: 10px;

      span {
        font-size: 13px;
      }
    }
  }
}

</style>
